// Advance by the actual result length: the API can cap pages below pageSize.
export async function fetchAllRows(createQuery, pageSize = 1000) {
  if (!Number.isInteger(pageSize) || pageSize < 1) throw new Error("Invalid page size");
  const rows = [];
  for (;;) {
    const { data, error } = await createQuery().range(rows.length, rows.length + pageSize - 1);
    if (error) throw error;
    if (!Array.isArray(data)) throw new Error("Invalid query response");
    if (data.length === 0) return rows;
    rows.push(...data);
  }
}
